export default __webpack_public_path__ + "static/media/aplikasi-1.3f7bfd90.JPG";